import React, { useRef } from 'react';
import { useDetectOutsideClick } from '@hooks/useDetectOutsideClick';
import { MenuOptionProps, NavigationOptions, OnClickProps } from '@types';
import { CodingConstants } from '@constants';
import { logOutAction } from '@store/actions/logout.actions';
import { clearCookie } from '@utils/cookieHelper';
import { auth, config } from '../../config';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserProfile } from '@store/selectors/widgets.selectors';
import { NavigationIcons, OptionLabel, OptionsWrapper, SingleOption } from './MenuOptions.styled';
import MenuDropDown from '@components/customDropdown/MenuDropDown';

const MenuOptions: React.FC<MenuOptionProps> = ({ heading, menuOptions, url, loanType, subMenuClick }) => {
    const dispatch = useDispatch();
    const userProfile: NavigationOptions = useSelector(selectUserProfile);
    const dropdownRef = useRef(null);
    const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
    const { escrow } = CodingConstants;

    const toggleMenu = () => setIsActive(!isActive);

    const onClick = async ({ name, url }: OnClickProps) => {
        switch (name) {
            case 'User Profile':
                clearCookie();
                auth.getOkta().tokenManager.clear();
                window.location.replace(`${userProfile.url}?${window.btoa(config.env('redirectUri'))}`);
                break;
            case 'Hardship Assistance':
                window.open(url, '_blank');
                break;
            case 'Escrow Assessment':
                loanType(escrow);
                break;
            case 'Payoff & Wire Transfer':
                window.open(url, '_blank');
                break;
            case 'FAQs':
                window.open(url, '_blank');
                break;
            case 'Disaster Assistance':
                loanType(CodingConstants.naturalDisasterAssistance);
                break;
            default:
                break;
        }
        setIsActive(false);
        subMenuClick();
    };

    const handleClick = (heading: string, url: string) => {
        if (heading === 'Log Out') {
            dispatch(logOutAction());
            auth.getOkta().signOut();
            auth.getOkta().tokenManager.clear();
            clearCookie();
        }
    };
    document.getElementById('contentContainer')?.addEventListener('click', () => setIsActive(false));
    return (
        <OptionsWrapper id="menuOptions" isActive={isActive}>
            <NavigationIcons id="navigationIcons">
                {url ? (
                    <SingleOption data-testid="logOutClick" onClick={() => handleClick(heading, url)}>
                        <label>{heading}</label>
                    </SingleOption>
                ) : (
                    <OptionLabel data-testid="toggleMenuClick" onClick={toggleMenu} isActive={isActive} ref={dropdownRef}>
                        <label>{heading}</label>
                        <img
                            data-testid="dropdownimg"
                            src="https://dam.freedommortgage.com/dx/api/dam/v1/collections/e9810627-8508-4c5f-b7f1-91b83e5c5489/items/00c9b7f7-b9b7-4988-b218-a69dcf74e939/renditions/7a934cd5-c5da-43f4-892c-0045b1e37ec7?binary=true"
                            width={13}
                            height={13}
                        />
                    </OptionLabel>
                )}
                {isActive && <MenuDropDown data-testid="menudropdownClick" options={menuOptions} onClick={onClick} />}
            </NavigationIcons>
        </OptionsWrapper>
    );
};

export default MenuOptions;
